var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldCreateWorkspace)?_c('Error',{attrs:{"error":"should-create-workspace"}}):_c('section',{attrs:{"id":"shopping"}},[_c('router-link',{attrs:{"to":"/bucket"}},[_c('button',[_vm._v("Créer un nouveau panier")])]),_c('BucketsList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }